import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UsersService } from '../_services/users.service';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { IuserInformation } from '../_types/userInterfaces.type';
import { ComponentRefService } from '../_services/componentRef.service';
import { SharedFunctionsService } from '../_services/sharedFunctions.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { Location } from '@angular/common';
import { ManualPasswordResetModalComponent } from '../modals/manualPasswordReset/manualPasswordResetModal.component';
import { PaginationInstance } from 'ngx-pagination'
import { UserProfileService } from '../../_services/user-profile.service';

declare var $: any;


@Component({
  selector: 'usersettings',
  templateUrl: './usersettings.component.html',
  styleUrls: ['./usersettings.component.css'],

}) 


export class UserSettingsComponent implements OnInit {

  public search: string = "";
  public selected: string = "";
  public loading: boolean = false;
  public ChildCheckBox: boolean = false;
  public MasterCheckBox: boolean = false;
  public UserPasswordReset: IuserInformation = <IuserInformation>{};
  public userProfiles: IuserInformation[];
  public usergroups: groups[] = [];
  public userSelectedCount: number = 0;
  public manualPasswordReset: string = "";
  public manualPasswordRestError: boolean = false;
  public companyGroups: companyGroups[] = [];
  public editGroupAssocMessage: string = "";
  public company: any;
  public disableUserMessage: string = "";
  public toggleProductioneerMessage: string = "";
  public userGroupsMessage: string = "";
  public newUserMessage: string = "";
  public multiplepasswordMessage: string = "";
  public disableUserAlertClass: string = "alert";
  public toggleProductioneerAlertClass: string = "alert";
  public createUserAlertClass: string = "alert";
  public editGroupAssocAlertClass: string = "alert";
  public multiplepasswordAlertClass: string = "alert";
  public manualPasswordAlertClass: string = "alert";
  public submitted: boolean = false;
  public newUser: userProfileInfo2 = <userProfileInfo2>{}
  public unsentEmailList: IuserInformation[] | null | undefined;
  public p: number = 1;
  public newPassword: string = '';
  private loginUsername: any;
  public massProdSubmit: boolean = false;
  public massCPSubmit: boolean = false;
  public massEmailSubmit: boolean = false;
  public massGroupSubmit: boolean = false;
  frmAddUser: UntypedFormGroup;
  public userCheckedList: any[] = [];
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = false;
  public t: boolean = true;
  public f: boolean = false;
  public dummbyValue = new Date();
  public config: PaginationInstance = {
    id: 'advanced',
    itemsPerPage: 10,
    currentPage: 1
  };
  public labels: any = {
    previousLabel: 'Previous',
    nextLabel: 'Next',
    screenReaderPaginationLabel: 'Pagination',
    screenReaderPageLabel: 'page',
    screenReaderCurrentLabel: `You're on page`
  };
  public up: any;

 
  @ViewChild(ManualPasswordResetModalComponent, { static: false }) passwordModalChild: ManualPasswordResetModalComponent;
  public sortArrayObj = {
    username: true,

  }


  constructor(private UserService: UsersService, private router: Router, private permissionsService: NgxPermissionsService, public ele: ElementRef, public location: Location, private fb: UntypedFormBuilder, private CompRefService: ComponentRefService, private SharedFunctions: SharedFunctionsService,
     public ups:UserProfileService) {
    this.CompRefService.userSetting = this;
    this.ups.userProfile$.subscribe(result => {
        this.up = result
    }    
    );
    
    this.permissionsService.hasPermission(["SUPERADMIN", "CONTROLPANELADMIN"]).then((result) => {
      if (!result) {
        router.navigate(([this.router.url + '/user']));
      }
    });

    this.frmAddUser = this.fb.group({
      'fullname': [null, Validators.compose([Validators.required])],
      'username': [null, Validators.compose([Validators.required])],
      'email': [null, Validators.compose([Validators.required, this.emailValidator])],
      'comment': [null],
      'password': [null],
    });
  }


  ngOnInit() {
    this.userProfiles = [];
    this.userSelectedCount = 0;
    this.MasterCheckBox = false;
    if (null != this.up) {
      this.company = this.up.currentCompany;
      this.loginUsername = this.up.name;
    }
    this.loading = true;
    this.UserService.getCompanyGroups()
      .subscribe(result => {
        if (typeof result != "string") {
          this.companyGroups = result;
          localStorage.setItem("companyGroups", JSON.stringify(this.companyGroups));
        }
      },
        (error: string) => {
          console.log(error);
        }
      );
    if (localStorage.getItem("userinfo") != null) {
      if (localStorage.getItem("userinfocompany") != null) {
        if (this.company === localStorage.getItem("userinfocompany")) {
          this.loadUserInfoFromAPI()

        } else {
          this.loadUserInfoFromAPI()
        }
      }
    }
    else {
      this.loadUserInfoFromAPI()
    }

  }

  orderList(columnName: string) {
    this.SharedFunctions.sortArray(this.userProfiles, columnName, this.sortArrayObj);
    if (this.sortArrayObj[columnName]) {
      this.sortArrayObj[columnName] = false;
    } else {
      this.sortArrayObj[columnName] = true;
    }
    this.dummbyValue = new Date();
  }


  checkForm() {

    let checkGood: boolean = true;
    if (this.frmAddUser.controls['fullname'].dirty && this.frmAddUser.controls['fullname'].valid) {
      checkGood = false;
    }
    if (this.frmAddUser.controls['username'].dirty && this.frmAddUser.controls['username'].valid) {
      checkGood = false;
    }
    if (this.frmAddUser.controls['email'].dirty && this.frmAddUser.controls['email'].valid) {
      checkGood = false;
    }
    if (this.frmAddUser.controls['password'].value) {
      const passMatches = this.frmAddUser.controls['password'].value.match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/);
      if (passMatches) {
        checkGood = false;
      }
    }
    else {
      checkGood = false;
    }

    return checkGood;
  }

  isUserChecked(c: IuserInformation) {
    if (c.isChecked) {
      return true;
    }
    return false;
  }

  modalLostFocus(divName: string, form: any, e: Event) {
    let element = document.getElementById(divName);
    if (element != null) {
     
      if (element.style.display == "none") {
        if (divName == 'passwordmodal') {
          this.passwordModalChild.modalLostFocus()
        } else {
          this.resetForm(divName, form);
        }
      }
    }
  }

  resetForm(divName: string, form: any) {
    form.reset();
    switch (divName) {
      case "disableusersmodal":
        this.disableUserAlertClass = "alert";
        this.disableUserMessage = "";
        break;
      case "passwordmodal":
        this.manualPasswordAlertClass = "alert";
        this.manualPasswordReset = "";
        break;
      case "createusermodal":
        this.createUserAlertClass = "alert";
        this.newUserMessage = "";
        this.frmAddUser.reset();
        break;
      case "addgroupmodal":
        this.editGroupAssocAlertClass = "alert";
        this.editGroupAssocMessage = "";
        break;
      case "multiplepasswordmodal":
        this.multiplepasswordAlertClass = "alert"
        this.multiplepasswordMessage = "";
        this.unsentEmailList = null;
        break;
      case 'toggleproductioneeraccessmodal':
        this.toggleProductioneerAlertClass = "alert";
        this.toggleProductioneerMessage = "";
        break;
      default:
        break;
    }
  }

  emailValidator(control: any) {
    if (control.value) {
      const matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
      return matches ? null : { 'invalidEmail': true };
    } else {
      return null;
    }
  }

  sendUserGroups(panelAccessChoice: string, form: any) {
    this.massGroupSubmit = true;
    $("#addgroupmodal").data('bs.modal')._config.backdrop = 'static';
    $("#addgroupmodal").data('bs.modal')._config.keyboard = false;
    let input = form.value;
    let users: Array<string> = [];
    let groups: Array<number> = [];
    groups.pop();
    users.pop();
    groups.push(input["groupselectiondropdown"]);
  
    for (let i = 0; i < this.userProfiles.length; i++) {
      if (this.userProfiles[i].isChecked) {
        users.push(this.userProfiles[i].username);                            
      }
    }
    if (this.userSelectedCount == 0) {
      this.massGroupSubmit = false;
      this.editGroupAssocAlertClass = "alert alert-danger";
      this.editGroupAssocMessage = "Please make sure to select at least 1 user.";
    }
    else {
      this.UserService.userGroupAssociation({ "Usernames": users, "CompanyName": String(this.company), "GroupIDs": groups }, String(this.company), panelAccessChoice)
        .subscribe(
          result => {
            this.massGroupSubmit = false;
            $("#addgroupmodal").data('bs.modal')._config.backdrop = true;
            $("#addgroupmodal").data('bs.modal')._config.keyboard = true;
            this.editGroupAssocAlertClass = "alert alert-success"
            this.editGroupAssocMessage = result;

          },
          error => {
            this.massGroupSubmit = false;
            $("#addgroupmodal").data('bs.modal')._config.backdrop = true;
            $("#addgroupmodal").data('bs.modal')._config.keyboard = true;
            this.editGroupAssocAlertClass = "alert alert-danger"
            this.editGroupAssocMessage = error;
          })
    }
  }

  massDisableUsers(enableDisable: boolean) {
    this.massCPSubmit = true;
    $("#disableusersmodal").data('bs.modal')._config.backdrop = 'static';
    $("#disableusersmodal").data('bs.modal')._config.keyboard = false;
    this.disableUserMessage = "";
    let users: Array<string> = [];
    if (this.userSelectedCount == 0) {
      this.massGroupSubmit = false;
      this.disableUserAlertClass = "alert alert-danger"
      this.disableUserMessage = "Please make sure to select at least 1 user.";
    }
    else {
      for (let i = 0; i < this.userProfiles.length - 1; i++) {
        if (this.userProfiles[i].isChecked == true) {
          users.push(this.userProfiles[i].username);
        }
      }

      this.UserService.disableUsers({ "Names": users }, this.company, enableDisable).subscribe(
        result => {
          this.massCPSubmit = false;
          $("#disableusersmodal").data('bs.modal')._config.backdrop = true;
          $("#disableusersmodal").data('bs.modal')._config.keyboard = true;
          this.disableUserAlertClass = "alert alert-success";
          this.disableUserMessage = "The editing of user company access was successful.";
          users.forEach(userItem => {
            this.userProfiles.forEach((item, index) => {
              if (item.username == userItem)
                item.hasPortalAccess = enableDisable;
              if (!enableDisable) {
              }

            })
          });
        }, error => {
          console.log(error);
          this.massCPSubmit = false;
          $("#disableusersmodal").data('bs.modal')._config.backdrop = true;
          $("#disableusersmodal").data('bs.modal')._config.keyboard = true;
          this.disableUserAlertClass = "alert alert-danger"
          this.disableUserMessage = "There was an error editing user company access."
        })
    }
  }

  massToggleProductioneerAccess(enableDisable: boolean) {
    this.massProdSubmit = true;
   
    $("#toggleproductioneeraccessmodal").data('bs.modal')._config.backdrop = 'static';
    $("#toggleproductioneeraccessmodal").data('bs.modal')._config.keyboard = false;
    this.toggleProductioneerMessage = "";
    let users: Array<string> = [];
    if (this.userSelectedCount == 0) {
      this.submitted = false;
      this.toggleProductioneerAlertClass = "alert alert-danger"
      this.toggleProductioneerMessage = "Please make sure to select at least 1 user.";
    }
    else {
      for (let i = 0; i < this.userProfiles.length - 1; i++) {
        if (this.userProfiles[i].isChecked == true) {
          users.push(this.userProfiles[i].username);
        }
      }

      this.UserService.toggleProductioneer({ "Names": users }, this.company, enableDisable).subscribe(
        result => {
          this.massProdSubmit = false;

          $("#toggleproductioneeraccessmodal").data('bs.modal')._config.backdrop = true;
          $("#toggleproductioneeraccessmodal").data('bs.modal')._config.keyboard = true;
          this.toggleProductioneerAlertClass = "alert alert-success";
          this.toggleProductioneerMessage = "The editing of user company access was successful.";
          users.forEach(userItem => {
            this.userProfiles.forEach((item, index) => {
              if (item.username == userItem)
                item.isApproved = enableDisable;
              if (!enableDisable) {
              }

            })
          });
        }, error => {
          console.log(error);
          this.massProdSubmit = false;
          $("#toggleproductioneeraccessmodal").data('bs.modal')._config.backdrop = true;
          $("#toggleproductioneeraccessmodal").data('bs.modal')._config.keyboard = true;
          this.toggleProductioneerAlertClass = "alert alert-danger"
          this.toggleProductioneerMessage = "There was an error editing user company access."
        })
    }
  }

  massPasswordEmailResest() {
    let users: Array<string> = [];
    this.unsentEmailList = null;
    this.massEmailSubmit = true;
    $("#multiplepasswordmodal").data('bs.modal')._config.backdrop = 'static';
    $("#multiplepasswordmodal").data('bs.modal')._config.keyboard = false;
    if (this.userSelectedCount == 0) {
      this.multiplepasswordMessage = "Please make sure to select at least 1 user.";
      this.multiplepasswordAlertClass = "alert alert-danger";
      this.submitted = false;
    }
    else {

      for (let i = 0; i < this.userProfiles.length - 1; i++) {
        if (this.userProfiles[i].isChecked == true) {
          users.push(this.userProfiles[i].email);
        }
      }

      this.UserService.sendMultiplePasswordResetEmail(users)
        .subscribe(
          result => {
            
            if (typeof (result) != "string") {
              this.multiplepasswordMessage = "Password reset emails sent to selected users.";
              this.multiplepasswordAlertClass = "alert alert-success";
              this.massEmailSubmit = false;
              $("#multiplepasswordmodal").data('bs.modal')._config.backdrop = true;
              $("#multiplepasswordmodal").data('bs.modal')._config.keyboard = true;
              result.forEach((item) => {
                if (item.success === false) {
                  if (this.unsentEmailList === undefined || this.unsentEmailList === null) {
                    this.unsentEmailList = [];
                  }
                  this.multiplepasswordMessage = "It seems some of the emails were not able to be sent.";
                  this.multiplepasswordAlertClass = "alert alert-info";
                  for (let i = 0; i < this.userProfiles.length - 1; i++) {
                    if (this.userProfiles[i].email == item.email) {
                      this.unsentEmailList.push(Object.assign({}, this.userProfiles[i]))
                    }
                  }
                }
                else {
                }
              })
            };
          },
          error => {
            console.log(error);
            this.multiplepasswordMessage = "An error occurred while trying to send some or all of the emails. Please try again.";
            this.multiplepasswordAlertClass = "alert alert-danger";
            this.massEmailSubmit = false;
            $("#multiplepasswordmodal").data('bs.modal')._config.backdrop = true;
            $("#multiplepasswordmodal").data('bs.modal')._config.keyboard = true;
          });
    }
  }

  singleDisableUsers(userinfo: IuserInformation, e: Event, access: string, index: number) {
    let enableDisable: boolean = false;
    let checkbox = <HTMLInputElement>document.getElementById(String(index) + "_CPAccess");
    userinfo.lockClass = "spinner-border spinner-border-sm";
    if (null != enableDisable) {

      if (checkbox.checked) {
        enableDisable = true;
      } else { enableDisable = false; }

      this.disableUserMessage = "";
      let user: Array<string> = [];
      user.push(userinfo.username);

      this.UserService.disableUsers({ "Names": user }, this.company, enableDisable).subscribe(
        result => {
          userinfo.lockClass = "";
          userinfo.hasPortalAccess = enableDisable;
        }, error => {
          e.preventDefault();
          console.log(error);
          userinfo.lockClass = "";
          if (checkbox.checked) {
            checkbox.checked = false;
          } else {
            checkbox.checked = true;
          }
        })
    }
    else {
      e.preventDefault();
      userinfo.lockClass = "";
    }
  }

  singleToggleProductioneerAccess(userinfo: IuserInformation, e: Event, access: string, index: number) {

    let enableDisable: boolean = false;
    let checkbox = <HTMLInputElement>document.getElementById(String(index) + "_ProAccess");
    userinfo.lockIcon = "spinner-border spinner-border-sm";
    if (null != enableDisable) {
      if (checkbox.checked) {
        enableDisable = true;
      } else { enableDisable = false; }

      this.disableUserMessage = "";
      let user: Array<string> = [];
      user.push(userinfo.username);
      this.UserService.toggleProductioneer({ "Names": user }, this.company, enableDisable).subscribe(
        result => {
          userinfo.lockIcon = "";
          userinfo.isApproved = enableDisable;
        }, error => {
          console.log(error);
          e.preventDefault();
          userinfo.lockIcon = "";
          if (checkbox.checked) {
            checkbox.checked = false;
          } else {
            checkbox.checked = true;
          }
          console.log(userinfo);
        })
    }
    else {
      e.preventDefault();
      userinfo.lockClass = "";
    }

  }

  newUserCreated() {
    this.submitted = true;
    this.newUserMessage = ""
    this.UserService.addUser(this.frmAddUser.value, this.company)
      .subscribe(result => {
        this.submitted = false;
        this.createUserAlertClass = "alert alert-success"
        this.newUserMessage = result
        let nu = Object.assign({}, this.createUseUserProfile())
        nu.lockClass = "btn btn-success"
        nu.lockIcon = "glyphicon glyphicon-ok"
        this.userProfiles.push(nu);
      },
        error => {
          this.submitted = false;
          this.createUserAlertClass = "alert alert-danger";
          this.newUserMessage = error;
        });
  }

  createUseUserProfile() {

    let newuser: IuserInformation = <IuserInformation>{};
    newuser.comment = this.frmAddUser.controls['comment'].value;
    newuser.email = this.frmAddUser.controls['email'].value;
    newuser.fullname = this.frmAddUser.controls['fullname'].value;
    newuser.username = this.frmAddUser.controls['username'].value;
    return newuser;
  }

  resetUserPassword(user: IuserInformation) {
    this.UserPasswordReset = user
  }

  resetpasswordmanual(form: any) {
    this.submitted = true;
    let username = this.UserPasswordReset.username;
    let input = form.value;
    if (input["password"] === input["repeat-password"]) {
      this.UserService.setUserPasswordReset(username, input["password"], false)
        .subscribe(result => {
          this.submitted = false;
          this.manualPasswordAlertClass = "alert alert-success"
          this.manualPasswordReset = result
        },
          error => {
            this.submitted = false;
            this.manualPasswordAlertClass = "alert alert-danger"
            this.manualPasswordReset = error
          })
    }
    else {
      this.submitted = false;
      this.manualPasswordAlertClass = "alert alert-danger"
      this.manualPasswordReset = "Please make sure both passwords match."

    }

  }

  sendUserResetEmail(email: string, username: string) {
    this.submitted = true;
    let el = document.getElementById("sendpasswordemail_" + username)
    if (el != null) {
      el.innerHTML = "Submitting...";
    }
    this.UserService.sendPasswordResetEmail(email)
      .subscribe(result => {
        alert(result);
        if (el != null) {
          el.innerHTML = "Send Email Reset";
        }
        this.submitted = false;
      },
        error => {
          alert(error);
          if (el != null) {
            el.innerHTML = "Send Email Reset";
          }
          this.submitted = false;
        });

  }

  checkUserDisabledStatus() {
    this.userProfiles.forEach((item, index) => {
     
      if (item.hasPortalAccess == false) {
        item.lockClass = "btn"
        item.lockIcon = ""
      } else {
        item.lockClass = "btn btn-success"
        item.lockIcon = "fas fa-check"
        item.lockClass = "btn"
        item.lockIcon = ""
      }

      if (item.isApproved) {
      }
    })
  }

  filterSelectedUsers() {

    if (this.search == "checked:true") {
      this.search = "";
    }
    else {
      this.search = "checked:true";
    }
    this.config.currentPage = 1;
  }

  loadUserInfoFromAPI() {

    this.UserService.getUsersInCompany(this.company)
      .subscribe(result => {
        if (typeof result != "string") {
          this.userProfiles = result;
          this.userProfiles.forEach((user) => {
            user.isChecked = this.f;
            
          });
          this.loading = false;
          this.checkUserDisabledStatus()

          if (this.company != null) {
            localStorage.setItem("userinfoCompany", this.company);
          }

        }

      },
        error => {
          console.log(error);
          this.loading = false;
        });
  }

  loadUserInfoFromLocalStorage() {
    var getitem: any;
    getitem = localStorage.getItem("userinfo")
    this.userProfiles = JSON.parse(getitem);
  }

  nameSelected(name: string) {
    this.search = name;
    this.selected = name;
  }

  checkIsCheckedList(c: IuserInformation) {
    let user: any;
    user = this.userCheckedList.find(u => ((u.username == c.username) && (u.companyUserID == c.companyUserID)))
    return user.isChecked;
  }

  returnUser() {
    return this.UserPasswordReset;
  }

  selectAllClicked() {
    let checked: number = 0;
    let ChildrenCheckBoxes: HTMLCollectionOf<Element> = document.getElementsByClassName("ChildCheckBox");
    let checkbox: HTMLInputElement
    for (let i = 0; i < ChildrenCheckBoxes.length; i++) {
      checkbox = <HTMLInputElement>ChildrenCheckBoxes[i]
      let userIndex = this.userProfiles.findIndex(u => checkbox.id == u.username);
  
        if (this.MasterCheckBox) {
          if (!this.userProfiles[userIndex].isChecked) {
            this.userProfiles[userIndex].isChecked = true;
            checked = checked + 1
          }
        }
        else {
          if (checkbox.checked) {
            this.userProfiles[userIndex].isChecked = false;
            checked = checked + 1
          }
        }   
    }


    if (this.MasterCheckBox == true) {
      this.userSelectedCount = this.userSelectedCount + checked;
    }
    else {
      this.userSelectedCount = this.userSelectedCount - checked;
    }

  }

  userSelected(value: boolean, user: IuserInformation) {
    let checkbox = <HTMLInputElement>document.getElementById(user.username);
    let userIndex = this.userProfiles.findIndex(u => u.companyUserID == user.companyUserID)
    checkbox.checked = value;
    if (value) {
      this.userSelectedCount += 1;    
      this.userProfiles[userIndex].isChecked = true;     
    }
    else {
      this.userSelectedCount -= 1;
      this.userProfiles[userIndex].isChecked = false;
    }
    if (this.userSelectedCount == 0) {
      this.MasterCheckBox = false
    }
  }

  getUserProfile(user: IuserInformation) {
    this.UserPasswordReset = user;
    localStorage.setItem("userMngProfile", JSON.stringify(user));
  }

  returnSingleSelectedUser() {
    let thing: any = {};
    this.userProfiles.forEach(item => {
      if (item.isChecked) {
        thing = Object.assign({}, item);
      }
    })
    return thing;
  }

  createCloneUser(mode: string, user: any) {
    let username: any;
    localStorage.setItem("mode", mode);
    if (mode == "cloneMode") {
      localStorage.setItem("userMngProfile", JSON.stringify(this.returnSingleSelectedUser()));
      username = this.returnSingleSelectedUser().username;
    } else if (mode == "editMode") {
      localStorage.setItem("userMngProfile", JSON.stringify(user));
      username = user.username;
    } else if (mode == "createMode"){
      username = user;
    }

    this.router.navigate([this.router.url + '/user/' + username ]);
  }

  compareUserName(username: string) {
    if (String(this.loginUsername).toLowerCase() == username.toLowerCase()) {
      return true;
    }
    return false;
  }

  pageChanged(number: number) {
    this.config.currentPage = number;
  }
}

interface groups {
  checked: boolean;
  name: string;
}

interface userProfileInfo2 {
  username: string;
  fullname: string;
  email: string;
  comment: string;
  passwordQuestion: string;
  passwordAnswer: string;
  isApproved: boolean;
  lastActivityDate: Date;
  lastLoginDate: Date;
  lastPasswordChangedDate: Date;
  creationDate: Date;
  firstTime: boolean;
  hasPortalAccess: boolean;
}

interface companyGroups {
  groupID: number;
  groupName: string;
  isChecked: boolean;
}
